/**
 * Cancer-specific Cell Specifications
 *
 * These cell specs use OpenAPI types as the source of truth for enum values.
 * Custom specs with special formatting are defined manually.
 */

import {
  RfpCancerHospiceBenefitType,
  RfpCancerScheduleBenefitType,
  extendEnumWithNotDisclosedAndNotOffered,
} from "@platform/openapi-types";

import {
  createEnumFormatter,
  createValueFormatter,
} from "../../components/PlanEditor/utilities/enumFormatters";
import { CellSpec } from "../shared/cellSpecs";

/**
 * Cancer hospice benefit type dropdown
 * Includes special "dollarAmountPerDayPerLifetime" option
 * Custom formatter for the special value
 */
export const cancerHospiceType: CellSpec = {
  singleClickEdit: true,
  cellType: "dropdown",
  dataType: "string",
  cellEditor: "agRichSelectCellEditor",
  cellEditorParams: {
    allowTyping: true,
    filterList: true,
    searchType: "matchAny",
    values: extendEnumWithNotDisclosedAndNotOffered(
      RfpCancerHospiceBenefitType,
    ),
    formatValue: createEnumFormatter({
      dollarAmountPerDayPerLifetime: "Dollar Amount per Day per Lifetime",
    }),
  },
  valueFormatter: createValueFormatter({
    dollarAmountPerDayPerLifetime: "Dollar Amount per Day per Lifetime",
  }),
  description: "Cancer hospice benefit type",
  validation: {
    required: true,
    allowedValues: extendEnumWithNotDisclosedAndNotOffered(
      RfpCancerHospiceBenefitType,
    ),
  },
};

/**
 * Cancer schedule benefit type dropdown
 * Used for skin cancer and surgical benefits
 * Custom formatter for "scheduleUpToDollarAmount"
 */
export const cancerScheduleBenefitType: CellSpec = {
  singleClickEdit: true,
  cellType: "dropdown",
  dataType: "string",
  cellEditor: "agRichSelectCellEditor",
  cellEditorParams: {
    allowTyping: true,
    filterList: true,
    searchType: "matchAny",
    values: extendEnumWithNotDisclosedAndNotOffered(
      RfpCancerScheduleBenefitType,
    ),
    formatValue: createEnumFormatter({
      scheduleUpToDollarAmount: "Schedule Up To Dollar Amount",
    }),
  },
  valueFormatter: createValueFormatter({
    scheduleUpToDollarAmount: "Schedule Up To Dollar Amount",
  }),
  description: "Cancer schedule benefit type (e.g., skin cancer, surgical)",
  validation: {
    required: true,
    allowedValues: extendEnumWithNotDisclosedAndNotOffered(
      RfpCancerScheduleBenefitType,
    ),
  },
};
